var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPadlock(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 12,
    height: 14,
    viewBox: "0 0 12 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1.99844 6.2001V4.6001C1.99844 2.39096 3.7893 0.600098 5.99844 0.600098C8.20758 0.600098 9.99844 2.39096 9.99844 4.6001V6.2001C10.8821 6.2001 11.5984 6.91644 11.5984 7.8001V11.8001C11.5984 12.6838 10.8821 13.4001 9.99844 13.4001H1.99844C1.11478 13.4001 0.398438 12.6838 0.398438 11.8001V7.8001C0.398438 6.91644 1.11478 6.2001 1.99844 6.2001ZM8.39844 4.6001V6.2001H3.59844V4.6001C3.59844 3.27461 4.67295 2.2001 5.99844 2.2001C7.32392 2.2001 8.39844 3.27461 8.39844 4.6001Z",
    fill: "#07070C"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPadlock);
export default __webpack_public_path__ + "static/media/padlock.23b76029e3c1a1b0a84d8deca86faf52.svg";
export { ForwardRef as ReactComponent };